var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUdp = function SvgUdp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-secondary-text)",
    fillRule: "evenodd",
    d: "M16.5.248V5.71l-16 6.454z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-secondary-text)",
    fillRule: "evenodd",
    d: "M13.5 0v9.433c0 2.742-2.239 4.965-5 4.965s-5-2.223-5-4.965V5.461l3-1.638v5.61c0 .96.784 1.738 1.75 1.738S10 10.393 10 9.433V1.911z",
    clipRule: "evenodd"
  })));
};
export default SvgUdp;